import AppCtaRenderer from '@/components/ui/appQrRenderer'
import { AppCta } from '@/services/cms-api/home-page-content/types'
import useIntl from '@/utils/intl'
import React, { FunctionComponent } from 'react'

interface Prop {
  apps: AppCta[]
}
const Apps: FunctionComponent<Prop> = ({ apps }) => {
  const { translate } = useIntl()
  if (apps === undefined || apps === null) {
    return <></>
  }

  const apps1 = apps.slice(0, 2)
  const apps2 = apps.slice(2, apps.length)

  return (
    <div id='apps' className='px-12 lg:py-24 py-16'>
      <div className='flex flex-col items-center justify-center'>
        <span className='2xl:text-5xl xl:text-4xl text-3xl text-textHigh font-extrabold text-center'>{translate('app.title')}</span>
        <div className='mt-20 lg:flex items-center justify-center px-28 w-full hidden'>
          <div className='flex flex-col gap-6'>
            {apps1.map((item: AppCta, i: number) => (
              <AppCtaRenderer id={'apps.' + item.id.toString()} key={i} item={item} align='left' />
            ))}
          </div>
          <hr className='h-[65vh] w-1 border-l border-dashed border-secondaryMidStroke' />
          <div className='flex flex-col gap-6'>
            {apps2.map((item: AppCta, i: number) => (
              <AppCtaRenderer id={'apps.' + item.id.toString()} key={i} item={item} align='right' />
            ))}
          </div>
        </div>
        <div className='flex gap-3 overflow-x-scroll scrollbar-thin lg:hidden w-[95vw] mt-10'>
          {apps.map((item: AppCta, i: number) => (
            <AppCtaRenderer id={'apps.' + item.id.toString()} key={i} item={item} />
          ))}

        </div>
      </div>
    </div>
  )
}
export default Apps
